export const LOGS_TYPE_REQUEST = "LOGS_TYPE_REQUEST";
export const LOGS_TYPE_SUCCESS = "LOGS_TYPE_SUCCESS";
export const LOGS_TYPE_FAILURE = "LOGS_TYPE_FAILURE";

export const Logs_Export_REQUEST = "Logs_Export_REQUEST";
export const Logs_Export_SUCCESS = "Logs_Export_SUCCESS";
export const Logs_Export_FAILURE = "Logs_Export_FAILURE";